export default "__VITE_ASSET__B5kIOdkQ__"